"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebglHelper = void 0;
const three_1 = require("three");
const TWEEN = __importStar(require("@tweenjs/tween.js"));
const utils_1 = require("../../utils/utils");
const Annotation_1 = require("../annotation/components/Annotation");
const Embed_1 = require("../embed/Embed");
const PubSub = __importStar(require("pubsub-js"));
const Measurement_1 = require("../measurement/Measurement");
const Background_1 = require("../backgroung/Background");
const ViewPosition_1 = require("../view-position/ViewPosition");
const objectParent_1 = require("./components/objectParent");
const mouse_1 = require("./services/mouse");
const intersection_1 = require("./services/intersection");
const ScaleUnit_1 = require("../scale-unit/ScaleUnit");
const backgroundConverter_1 = require("../../api/converters/backgroundConverter");
const measurementConverter_1 = require("../../api/converters/measurementConverter");
const lightConverter_1 = require("../../api/converters/lightConverter");
const modelConverter_1 = require("../../api/converters/modelConverter");
const General_1 = require("../general/General");
const Light_1 = require("../light/Light");
const Screenshot_1 = require("../screenshot/Screenshot");
const Toast_1 = require("../toast/Toast");
const SideToolbar_1 = require("../side-toolbar/SideToolbar");
const i18next_1 = __importDefault(require("i18next"));
const NexusLoader_1 = require("../../loaders/NexusLoader");
const nexus_viewer_lib_1 = require("nexus-viewer-lib");
const ViewerOptions_1 = require("../../objects/ViewerOptions");
const AnnotationSwitcher_1 = require("../annotation/components/AnnotationSwitcher");
const AnnotationService_1 = require("../annotation/components/AnnotationService");
const AnnotationList_1 = require("../annotation/components/AnnotationList");
const LoadingDisplay_1 = require("../loading-display/LoadingDisplay");
const pubsub_js_1 = require("pubsub-js");
class WebglHelper {
    constructor(webgl, apiService, assetId, hasEditor) {
        this.eventSubscriptions = [];
        this.initialCamPosition = new three_1.Vector3(0, 0, 10);
        this.initialTargetPosition = new three_1.Vector3(0, 0, 0);
        this.clickStartPosition = new three_1.Vector2();
        this.isDrawing = false;
        this.mouse = new three_1.Vector2();
        this.editorType = "nav-view" /* NONE */;
        this.webglHelperFunctions = {
            mouseDown: (event) => this.onMouseDown(event),
            mouseUp: (event) => this.onMouseUp(event),
            mouseMove: (event) => this.onMouseMove(event),
            keyUp: (event) => this.onKeyUp(event)
        };
        this.webgl = webgl;
        this.apiService = apiService;
        this.assetId = assetId;
        this.annotationService = new AnnotationService_1.AnnotationService(this.webgl, this.apiService, []);
        this.addEvents();
        this.intersections = new intersection_1.Intersections();
        // Viewer
        // this.compass = new Compass(this.webgl);
        this.EmbedIcon = new Embed_1.EmbedIcon(this.assetId, ViewerOptions_1.ViewerOptions.assetVersionType, ViewerOptions_1.ViewerOptions.showEmbedIcon);
        this.loadingDisplay = new LoadingDisplay_1.LoadingDisplay(ViewerOptions_1.ViewerOptions.viewType);
        this.sideToolbar = new SideToolbar_1.SideToolbar();
        this.annotationSwitcher = new AnnotationSwitcher_1.AnnotationSwitcher();
        if (ViewerOptions_1.ViewerOptions.viewType === ViewerOptions_1.ViewType.LIGHT) {
            this.annotationService.showAnnotationHotspots();
            return;
        }
        // this.viewPosition = new ViewPosition(this.webgl);
        // this.measurement = new Measurement(this.webgl);
        // this.modelQuality = new ModelQuality(this.webgl);
        // Editor
        if (hasEditor) {
            this.viewPosition = new ViewPosition_1.ViewPosition(this.webgl);
            this.measurement = new Measurement_1.Measurement();
            this.general = new General_1.General(this.webgl);
            this.background = new Background_1.Background(this.webgl);
            this.light = new Light_1.Light(this.webgl);
            this.screenshot = new Screenshot_1.Screenshot(this.webgl);
            this.scaleUnit = new ScaleUnit_1.ScaleUnit(this.webgl);
            this.annotationList = new AnnotationList_1.AnnotationList(this.webgl, this.annotationService, this.apiService, hasEditor);
            // Annotation
            // TODO: some part of annotations should work even if sidebar or editor is disabled...
            // this.annotations = new AnnotationList(this.webgl, this.apiService, hasEditor);
        }
        this.webgl.renderer.domElement.style.cursor = 'grab';
    }
    dispose() {
        this.removeEvents();
        delete this.compass;
        delete this.viewPosition;
        delete this.measurement;
        delete this.modelQuality;
        delete this.general;
        delete this.background;
        delete this.light;
        delete this.scaleUnit;
    }
    addEvents() {
        this.webgl.renderer.domElement.addEventListener('mousedown', this.webglHelperFunctions.mouseDown);
        this.webgl.renderer.domElement.addEventListener('mousemove', this.webglHelperFunctions.mouseMove);
        document.addEventListener('keyup', this.webglHelperFunctions.keyUp);
        const subscriptions = [
            PubSub.subscribe("editor-mode" /* EDITOR_MODE */, (_, data) => this.editorModeChange(data)),
            PubSub.subscribe("initial-position-set" /* INITIAL_POSITION_SET */, (_, data) => this.setInitialPositionAndTarget(data)),
            PubSub.subscribe("initial-position-goto" /* INITIAL_POSITION_GOTO */, () => this.goToInitialPosition()),
            PubSub.subscribe("save" /* SAVE */, (_, onSave) => this.saveAll(onSave)),
            PubSub.subscribe("scene-override-change" /* SCENE_OVERRIDE_CHANGE */, (_, data) => this.sceneOverrideChange(data)),
            PubSub.subscribe("light-selected" /* LIGHT_SELECTED */, (_, data) => this.changeSelected(data)),
            PubSub.subscribe("object-transform-mode" /* OBJECT_TRANSFORM_MODE */, (_, mode) => this.modelTransformMode(mode)),
            PubSub.subscribe("object-transform-toggle" /* OBJECT_TRANSFORM_SPACE_TOGGLE */, () => this.modelTransformSpaceToggle()),
            PubSub.subscribe("object-transform-flip" /* OBJECT_TRANSFORM_FLIP */, () => this.flipObject()),
            PubSub.subscribe("take-screenshot" /* TAKE_SCREENSHOT */, (_, callback) => {
                this.takeScreenshot(callback);
            }),
            PubSub.subscribe("upload-thumbnail" /* UPLOAD_THUMBNAIL */, (_, blob) => {
                this.uploadThumbnail(blob);
            }),
            PubSub.subscribe("get-thumbnail-url" /* GET_THUMBNAIL_URL */, (_, callback) => {
                this.downloadThumbnail(callback);
            }),
            PubSub.subscribe("change-model-quality" /* CHANGE_MODEL_QUALITY */, (_, quality) => {
                this.setNexusQuality(quality);
            }),
            PubSub.subscribe("change-model-view-position" /* CHANGE_MODEL_VIEW_POSITION */, (_, positionType) => {
                this.changeModelViewPosition(positionType);
            }),
            PubSub.subscribe("annotation-add-many" /* ANNOTATION_ADD_MANY */, (_, annotations) => {
                this.initAnnotations(annotations);
            }),
            PubSub.subscribe("annotation-goto" /* ANNOTATION_GOTO */, (_, annotation) => {
                var _a;
                (_a = this.annotationService) === null || _a === void 0 ? void 0 : _a.goToHotSpot(annotation);
            }),
            PubSub.subscribe("annotation-hotspots" /* ANNOTATION_HOTSPOTS */, (_, show) => {
                var _a, _b;
                if (show) {
                    (_a = this.annotationService) === null || _a === void 0 ? void 0 : _a.showAnnotationHotspots();
                }
                else {
                    (_b = this.annotationService) === null || _b === void 0 ? void 0 : _b.hideAnnotationHotspots();
                }
            })
        ];
        this.eventSubscriptions.push(...subscriptions);
    }
    initAnnotations(annotations) {
        var _a;
        (_a = this.annotationService) === null || _a === void 0 ? void 0 : _a.addAll(annotations);
        (0, pubsub_js_1.publish)("show-annotation-switcher" /* SHOW_ANNOTATION_SWITCHER */);
    }
    modelTransformSpaceToggle() {
        var _a;
        (_a = this.webgl.modelTransformService) === null || _a === void 0 ? void 0 : _a.toggleSpace();
    }
    modelTransformMode(mode) {
        var _a;
        (_a = this.webgl.modelTransformService) === null || _a === void 0 ? void 0 : _a.changeModeTo(mode);
    }
    flipObject() {
        var _a;
        (_a = this.webgl.modelTransformService) === null || _a === void 0 ? void 0 : _a.flipYZ();
    }
    removeEvents() {
        this.webgl.renderer.domElement.removeEventListener('mousedown', this.webglHelperFunctions.mouseDown);
        this.webgl.renderer.domElement.removeEventListener('mouseup', this.webglHelperFunctions.mouseUp);
        this.webgl.renderer.domElement.removeEventListener('mousemove', this.webglHelperFunctions.mouseMove);
        document.removeEventListener('keyup', this.webglHelperFunctions.keyUp);
        this.eventSubscriptions.forEach((subscription) => PubSub.unsubscribe(subscription));
        this.eventSubscriptions = [];
    }
    onMouseDown(event) {
        var _a;
        this.webgl.renderer.domElement.removeEventListener('mousemove', this.webglHelperFunctions.mouseMove);
        this.webgl.renderer.domElement.style.cursor = 'grabbing';
        if (this.editorType !== "nav-annotation" /* ANNOTATION */) {
            (_a = this.annotationService) === null || _a === void 0 ? void 0 : _a.show(undefined);
        }
        this.mouse = (0, mouse_1.mousePosition)(event, this.webgl.renderer.domElement);
        this.clickStartPosition = this.mouse.clone();
        this.isDrawing = true;
        this.webgl.renderer.domElement.addEventListener('mouseup', this.webglHelperFunctions.mouseUp);
    }
    onMouseMove(event) {
        if (this.editorType === "nav-view" /* NONE */) {
            return;
        }
        const mouse = (0, mouse_1.mousePosition)(event, this.webgl.renderer.domElement);
        const intersects = this.intersections.getIntersections(mouse, this.webgl.managableObjects, this.webgl.camera, true);
        this.webgl.renderer.domElement.style.cursor = intersects ? 'pointer' : 'grab';
    }
    onMouseUp(event) {
        var _a, _b, _c, _d, _e, _f;
        this.webgl.renderer.domElement.addEventListener('mousemove', this.webglHelperFunctions.mouseMove);
        const cursor = this.webgl.renderer.domElement.style.cursor;
        this.webgl.renderer.domElement.style.cursor = cursor === 'grabbing' ? 'grab' : cursor;
        if (!this.isDrawing) {
            return;
        }
        this.isDrawing = false;
        this.mouse = (0, mouse_1.mousePosition)(event, this.webgl.renderer.domElement);
        if (!this.clickStartPosition.equals(this.mouse)) {
            this.removeMouseUpEventListener();
            return;
        }
        if (this.editorType !== "nav-annotation" /* ANNOTATION */) {
            (_a = this.annotationService) === null || _a === void 0 ? void 0 : _a.show(undefined);
        }
        if (this.editorType !== "nav-model" /* MODEL */ && this.webgl.modelTransformService && this.webgl.modelTransformService.hasControlsAttached) {
            this.webgl.modelTransformService.detachObject();
        }
        let managableObjects = this.webgl.managableObjects;
        if (this.editorType === "nav-model" /* MODEL */ || this.editorType === "nav-annotation" /* ANNOTATION */ || this.editorType === "nav-view" /* NONE */) {
            // Remove lights from managableObjects
            //@ts-ignore
            managableObjects = this.webgl.managableObjects.filter(o => !o.light);
        }
        if (this.editorType === "nav-light" /* LIGHT */) {
            // Remove model (mesh) from managableObjects
            //@ts-ignore
            managableObjects = this.webgl.managableObjects.filter(o => o.light);
        }
        const intersects = this.intersections.getIntersections(this.mouse, managableObjects, this.webgl.camera, true);
        if (!intersects) {
            this.removeMouseUpEventListener();
            // Model cannot be unselected in 'model' tab
            if (this.editorType === "nav-model" /* MODEL */) {
                return;
            }
            this.changeSelected(undefined);
            return;
        }
        let annotation = null;
        const sprite = intersects.find((intersect) => intersect.object.type === 'Sprite');
        const closestPick = intersects[0];
        // View, edit models or edit annotations
        switch (this.editorType) {
            case "nav-view" /* NONE */:
                if (sprite) {
                    annotation = (_b = this.annotationService) === null || _b === void 0 ? void 0 : _b.get(sprite.object.uuid);
                    if (!annotation) {
                        console.log('Annotation not found: ' + sprite.object.uuid);
                        return;
                    }
                    PubSub.publish("annotation-goto" /* ANNOTATION_GOTO */, annotation);
                }
                else {
                    const modelParent = intersects[0]; // TODO: maybe show parent of clicked object?
                }
                break;
            case "nav-model" /* MODEL */:
                if (closestPick.object.type !== "Sprite" /* SPRITE */) {
                    const intersectRoot = (0, objectParent_1.determinParent)(closestPick.object);
                    if (!intersectRoot) {
                        throw new Error('Root object is undefined');
                    }
                    this.changeSelected(intersectRoot);
                }
                break;
            case "nav-light" /* LIGHT */:
                if (closestPick.object.type !== "Sprite" /* SPRITE */) {
                    const intersectRoot = (0, objectParent_1.determinParent)(closestPick.object);
                    if (!intersectRoot) {
                        throw new Error('Root object is undefined');
                    }
                    this.changeSelected(intersectRoot);
                }
                break;
            case "nav-annotation" /* ANNOTATION */:
                console.log('Editor mode: ANNOTATION');
                if (sprite) {
                    annotation = (_c = this.annotationService) === null || _c === void 0 ? void 0 : _c.get(sprite.object.uuid);
                    if (annotation) {
                        (_d = this.annotationService) === null || _d === void 0 ? void 0 : _d.show(sprite.object.uuid);
                        PubSub.publish("show-annotation-in-menu" /* ANNOTATION_SHOW_MENU */, annotation);
                    }
                }
                else {
                    const point = intersects[0].point; // get closest clicked object point
                    const camera = this.webgl.camera.position;
                    const newAnnotation = {
                        manualId: utils_1.Uuid.generate(),
                        id: undefined,
                        name: undefined,
                        content: undefined,
                        url: undefined,
                        annotationPoint: { x: point.x, y: point.y, z: point.z },
                        cameraPoint: { x: camera.x, y: camera.y, z: camera.z },
                        orderNumber: ((_e = this.annotationService) === null || _e === void 0 ? void 0 : _e.getHighestOrderNumber()) || 0
                    };
                    const annotation = new Annotation_1.Annotation(newAnnotation);
                    annotation.annotationPopover.element.visible = true;
                    (_f = this.annotationService) === null || _f === void 0 ? void 0 : _f.add(annotation);
                    // Open annotation edit window in menu
                    PubSub.publish("show-annotation-in-menu" /* ANNOTATION_SHOW_MENU */, annotation);
                }
                break;
            default:
                console.log('Unknown editor type: ' + this.editorType);
                break;
        }
        this.removeMouseUpEventListener();
    }
    onKeyUp(event) {
        var _a, _b;
        if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.nodeName) === 'INPUT') {
            return;
        }
        if (event.key === 'Delete') {
            let object = this.webgl.selected;
            if (!object) {
                return;
            }
            this.webgl.modelTransformService.detachObject();
            if (object instanceof three_1.DirectionalLight ||
                object instanceof three_1.SpotLight ||
                object instanceof three_1.PointLight) {
                (_b = this.webgl) === null || _b === void 0 ? void 0 : _b.lights.remove(object);
            }
            this.changeSelected(undefined);
        }
    }
    removeMouseUpEventListener() {
        this.webgl.renderer.domElement.removeEventListener('mouseup', this.webglHelperFunctions.mouseUp);
    }
    setInitialPositionAndTarget(data) {
        this.initialCamPosition.copy(data.cameraPosition);
        this.initialTargetPosition.copy(data.orbitTarget);
    }
    changeModelViewPosition(positionType) {
        var _a, _b, _c, _d;
        const sphere = this.boundingSphere();
        const diameter = sphere.radius * 2;
        const center = sphere.center;
        let cameraPosition;
        switch (positionType) {
            case 1 /* FRONT */:
                cameraPosition = new three_1.Vector3(0, 0, diameter);
                break;
            case 2 /* BACK */:
                cameraPosition = new three_1.Vector3(0, 0, -diameter);
                break;
            case 3 /* LEFT */:
                cameraPosition = new three_1.Vector3(-diameter, 0, 0);
                break;
            case 4 /* RIGHT */:
                cameraPosition = new three_1.Vector3(diameter, 0, 0);
                break;
            case 5 /* TOP */:
                cameraPosition = new three_1.Vector3(0, diameter, 0);
                break;
            case 6 /* BOTTOM */:
                cameraPosition = new three_1.Vector3(0, -diameter, 0);
                break;
        }
        (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.camera.position.copy(cameraPosition);
        // this.webgl.camera.rotation.set(pitch, yaw, 0);
        (_b = this.webgl) === null || _b === void 0 ? void 0 : _b.camera.lookAt(center);
        (_c = this.webgl) === null || _c === void 0 ? void 0 : _c.orbitControls.target.copy(center);
        (_d = this.webgl) === null || _d === void 0 ? void 0 : _d.renderOnce();
    }
    boundingSphere() {
        var _a, _b;
        // TODO: what if two models are loaded? Now only first is selected
        const object = (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.scene.getObjectByProperty('uuid', (_b = this.webgl) === null || _b === void 0 ? void 0 : _b.loadedObjectsIds[0].val);
        if (!object) {
            throw new Error("Object is not under loadedObjectsIds");
        }
        const boxHelper = new three_1.BoxHelper(object);
        boxHelper.geometry.computeBoundingSphere();
        const boundingSphere = boxHelper.geometry.boundingSphere;
        if (!boundingSphere) {
            throw new Error("Bounding sphere is undefined");
        }
        return boundingSphere;
    }
    goToInitialPosition() {
        this.webgl.startRendering();
        this.webgl.camera.lookAt(this.initialTargetPosition);
        new TWEEN.Tween(this.webgl.camera.position)
            .to(this.initialCamPosition, 1000)
            .easing(TWEEN.Easing.Circular.Out)
            .start();
        new TWEEN.Tween(this.webgl.orbitControls.target)
            .to(this.initialTargetPosition, 1000)
            .easing(TWEEN.Easing.Circular.Out)
            .start()
            .onComplete(() => this.webgl.stopRendering());
    }
    setNexusQuality(qualityType) {
        if (!this.webgl) {
            throw new Error("Webgl is undefined");
        }
        const nexusProps = {
            targetError: NexusLoader_1.NexusDefaultSettings.TARGET_ERROR,
            targetFps: NexusLoader_1.NexusDefaultSettings.TARGET_FPS,
            maxPending: NexusLoader_1.NexusDefaultSettings.MAX_PENDING,
            maxBlocked: NexusLoader_1.NexusDefaultSettings.MAX_BLOCKED,
            maxCacheSize: NexusLoader_1.NexusDefaultSettings.MAX_CACHE_SIZE,
            drawBudget: NexusLoader_1.NexusDefaultSettings.DRAW_BUDGET
        };
        switch (qualityType) {
            case "low" /* LOW */:
                nexusProps.targetError = 10;
                nexusProps.targetFps = 40;
                nexusProps.maxPending = 7;
                nexusProps.maxBlocked = 3;
                nexusProps.maxCacheSize = 512 * (1 << 20);
                nexusProps.drawBudget = 16 * (1 << 20);
                break;
            case "mid" /* MID */:
                nexusProps.targetError = 1;
                nexusProps.targetFps = 30;
                nexusProps.maxPending = 5;
                nexusProps.maxBlocked = 5;
                nexusProps.maxCacheSize = 1024 * (1 << 20);
                nexusProps.drawBudget = 32 * (1 << 20);
                break;
            case "high" /* HIGH */:
                nexusProps.targetError = 0.1;
                nexusProps.targetFps = 20;
                nexusProps.maxPending = 3;
                nexusProps.maxBlocked = 7;
                nexusProps.maxCacheSize = 2048 * (1 << 20);
                nexusProps.drawBudget = 64 * (1 << 20);
                break;
            default: throw new Error("Model quality type is undefined");
        }
        nexus_viewer_lib_1.Nexus.getContext(this.webgl.renderer.getContext()).settings.targetError = nexusProps.targetError;
        nexus_viewer_lib_1.Nexus.getContext(this.webgl.renderer.getContext()).settings.targetFps = nexusProps.targetFps;
        nexus_viewer_lib_1.Nexus.getContext(this.webgl.renderer.getContext()).settings.maxPending = nexusProps.maxPending;
        nexus_viewer_lib_1.Nexus.getContext(this.webgl.renderer.getContext()).settings.maxBlocked = nexusProps.maxBlocked;
        nexus_viewer_lib_1.Nexus.getContext(this.webgl.renderer.getContext()).settings.maxCacheSize = nexusProps.maxCacheSize;
        nexus_viewer_lib_1.Nexus.getContext(this.webgl.renderer.getContext()).settings.drawBudget = nexusProps.drawBudget;
        this.webgl.renderOnce();
    }
    changeSelected(object) {
        let obj = object;
        if (object instanceof three_1.DirectionalLightHelper ||
            object instanceof three_1.SpotLightHelper ||
            object instanceof three_1.PointLightHelper) {
            obj = object.light;
        }
        if (obj) {
            this.webgl.modelTransformService.attachObject(obj);
        }
        this.webgl.selected = obj;
        PubSub.publish("object-info" /* OBJECT_INFO */, obj);
    }
    // Save scene and annotations
    saveAll(onSave) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const sceneOverride = this.webgl.sceneOverride;
            // Background
            const background = (_a = this.background) === null || _a === void 0 ? void 0 : _a.getData();
            sceneOverride.background = (0, backgroundConverter_1.convertBackgroundToOverride)(background);
            // Measurement
            const measurement = (_b = this.scaleUnit) === null || _b === void 0 ? void 0 : _b.getData();
            sceneOverride.measurement = (0, measurementConverter_1.convertMeasurementToOverride)(measurement);
            // Lights
            sceneOverride.lights = [];
            const lightsKeyVal = (_c = this.webgl) === null || _c === void 0 ? void 0 : _c.lights.lightsKeyValList.keyValList;
            lightsKeyVal === null || lightsKeyVal === void 0 ? void 0 : lightsKeyVal.forEach((keyVal) => {
                const light = this.webgl.scene.getObjectByProperty('uuid', keyVal.val);
                if (!light) {
                    console.log("Light not found: " + keyVal.val + " (" + keyVal.key + ")");
                    onSave(false);
                    return;
                }
                const lightOverride = (0, lightConverter_1.convertLightToOverride)(keyVal, light);
                sceneOverride.lights.push(lightOverride);
            });
            // Models
            sceneOverride.models = [];
            const modelsKeyVal = this.webgl.loadedObjectsIds;
            modelsKeyVal.forEach((keyVal) => {
                const model = this.webgl.scene.getObjectByProperty('uuid', keyVal.val);
                if (!model) {
                    console.log("Model not found: " + keyVal.val + " (" + keyVal.key + ")");
                    onSave(false);
                    return;
                }
                const modelOverride = (0, modelConverter_1.convertModelToOverride)(keyVal, model);
                sceneOverride.models.push(modelOverride);
            });
            try {
                yield this.apiService.updateSceneOverride(sceneOverride);
                yield ((_d = this.annotationService) === null || _d === void 0 ? void 0 : _d.save());
                onSave(true);
            }
            catch (_e) {
                onSave(false);
            }
            // Used to reset object previous reset values
            this.webgl.modelTransformService.resetObjectValues();
        });
    }
    sceneOverrideChange(sceneOverride) {
        this.webgl.sceneOverride = sceneOverride;
        this.changeBackground(sceneOverride.background);
        this.changeScaleUnit(sceneOverride.measurement);
        this.changeLights(sceneOverride.lights);
    }
    changeBackground(backgroundOverride) {
        if (this.background) {
            this.background.setInitialData(backgroundOverride);
        }
        else { // This happens when 'light' menu is active, because 'Background' class does not exist
            switch (backgroundOverride.type) {
                case "UNSPECIFIED" /* UNSPECIFIED */:
                    this.webgl.scene.background = null;
                    break;
                case "COLOR" /* COLOR */:
                    const hexColor = parseInt(backgroundOverride.color.substring(1), 16);
                    this.webgl.scene.background = new three_1.Color(hexColor).convertLinearToSRGB();
                    (0, pubsub_js_1.publish)("background-changed" /* BACKGROUND_CHANGED */, backgroundOverride.color);
                    break;
                case "TEXTURE" /* TEXTURE */:
                    if (backgroundOverride.texture) {
                        new three_1.TextureLoader().load(backgroundOverride.texture, (texture) => {
                            this.webgl.scene.background = texture;
                            this.webgl.renderOnce();
                        });
                    }
                    break;
                default: throw new Error("Unknown background type: " + backgroundOverride.type);
            }
            this.webgl.renderOnce();
        }
    }
    changeScaleUnit(data) {
        if (this.scaleUnit) {
            this.scaleUnit.setData(data);
        }
        else {
            // Do nothing for now
        }
    }
    changeLights(lights) {
        var _a;
        for (const lightOverride of lights) {
            const light = (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.lights.add(lightOverride.type, lightOverride.id);
            light.position.set(lightOverride.position.x, lightOverride.position.y, lightOverride.position.z);
            light.rotation.set(lightOverride.rotation.x, lightOverride.rotation.y, lightOverride.rotation.z);
            light.scale.set(lightOverride.scale.x, lightOverride.scale.y, lightOverride.scale.z);
            light.intensity = lightOverride.intensity;
            const hexColor = parseInt(lightOverride.color.substring(1), 16);
            light.color.set(new three_1.Color().setHex(hexColor));
            if (light.distance) {
                light.distance = lightOverride.distance;
            }
            if (light.decay) {
                light.decay = lightOverride.decay;
            }
            if (light.angle) {
                light.angle = lightOverride.angle;
            }
            if (light.penumbra) {
                light.penumbra = lightOverride.penumbra;
            }
            if (light.decay) {
                light.decay = lightOverride.decay;
            }
        }
    }
    // TODO: ???
    editorModeChange(editorType) {
        this.editorType = editorType;
        this.clearPreviousEditor();
        this.setCurrentEditor(editorType);
        this.webgl.renderOnce();
    }
    clearPreviousEditor() {
        var _a, _b, _c;
        // Model
        // this.modelTransform?.removeControls();
        this.webgl.modelTransformService.removeControls();
        // Light
        (_a = this.light) === null || _a === void 0 ? void 0 : _a.hideLightHelpers();
        // Annotation
        if (this.annotationService) {
            this.annotationService.isEditable = false;
        }
        (_b = this.annotationService) === null || _b === void 0 ? void 0 : _b.show(undefined);
        // Measurement
        (_c = this.measurement) === null || _c === void 0 ? void 0 : _c.clear();
    }
    setCurrentEditor(editorType) {
        var _a, _b, _c;
        switch (editorType) {
            case "nav-view" /* NONE */:
                (0, pubsub_js_1.publish)("show-annotation-switcher" /* SHOW_ANNOTATION_SWITCHER */);
                this.webgl.renderer.domElement.style.cursor = 'grab';
                break;
            case "nav-model" /* MODEL */:
                (0, pubsub_js_1.publish)("hide-annotation-switcher" /* HIDE_ANNOTATION_SWITCHER */);
                (_a = this.webgl.modelTransformService) === null || _a === void 0 ? void 0 : _a.createControls();
                this.selectModel();
                break;
            case "nav-light" /* LIGHT */:
                (0, pubsub_js_1.publish)("hide-annotation-switcher" /* HIDE_ANNOTATION_SWITCHER */);
                (_b = this.webgl.modelTransformService) === null || _b === void 0 ? void 0 : _b.createControls();
                (_c = this.light) === null || _c === void 0 ? void 0 : _c.showLightHelpers();
                break;
            case "nav-annotation" /* ANNOTATION */:
                if (this.annotationService) {
                    this.annotationService.isEditable = true;
                }
                (0, pubsub_js_1.publish)("show-annotation-switcher" /* SHOW_ANNOTATION_SWITCHER */);
                break;
            default: throw new Error('Undefined editor type');
        }
    }
    selectModel() {
        const model = this.webgl.managableObjects.find(o => o.type === 'Mesh');
        this.changeSelected(model);
    }
    takeScreenshot(callback) {
        var _a, _b;
        let showGridAfterScreenshot = false;
        let showAxisAfterScreenshot = false;
        let showTransformCtrlsAfterScreenshot = false;
        if (this.webgl.modelTransformService.areControlsVisible) {
            this.webgl.modelTransformService.hideControls();
            showTransformCtrlsAfterScreenshot = true;
        }
        if ((_a = this.general) === null || _a === void 0 ? void 0 : _a.isGridHelperVisible) {
            this.general.hideGridHelper();
            showGridAfterScreenshot = true;
        }
        if ((_b = this.general) === null || _b === void 0 ? void 0 : _b.isAxisHelperVisible) {
            this.general.hideAxisHelper();
            showAxisAfterScreenshot = true;
        }
        this.webgl.renderOnce();
        this.webgl.renderer.domElement.toBlob((blob) => {
            var _a, _b;
            if (!blob) {
                return;
            }
            if (showTransformCtrlsAfterScreenshot) {
                this.webgl.modelTransformService.showControls();
            }
            if (showGridAfterScreenshot) {
                (_a = this.general) === null || _a === void 0 ? void 0 : _a.showGridHelper();
            }
            if (showAxisAfterScreenshot) {
                (_b = this.general) === null || _b === void 0 ? void 0 : _b.showAxisHelper();
            }
            callback(blob);
        }, 'image/webp', 1);
    }
    uploadThumbnail(thumbBlob) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('file', thumbBlob);
            this.apiService.uploadThumbnail(formData).then(() => {
                Toast_1.Toast.create('success', i18next_1.default.t("THUMBNAIL_SET"));
            });
        });
    }
    downloadThumbnail(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const thumbnailBlobUrl = yield this.apiService.downloadAssetThumbnail(this.assetId);
            callback(thumbnailBlobUrl);
        });
    }
}
exports.WebglHelper = WebglHelper;
